export default {
    "resultSelector": {
        "selectDocument": "Sélectionner le document",
        "unselectDocument": "Désélectionner le document"
    },
    "resultsSelector": {
        "selectDocuments": "{count, selectordinal, =0 {} other {(#)}}",
        "selectDocumentsTitle": "Sélectionner les documents",
        "unselectDocumentsTitle": "Désélectionner les documents",
    },
    "selection": {
        "selectedDocuments": "{count, plural, =0 {} one {# document sélectionné} other {# documents sélectionnés}}"
    }
};
